'use client';
import { forwardRef } from 'react';
import { identity } from './factory.mjs';

function polymorphicFactory(ui) {
  const Component = forwardRef(ui);
  Component.extend = identity;
  return Component;
}

export { polymorphicFactory };
//# sourceMappingURL=polymorphic-factory.mjs.map
